import { Breakpoint } from "../useBreakpoint/useBreakpoint.types.js";

export const BREAKPOINTS_FONT_SIZE_MULTIPLIER: Record<Breakpoint, number> = {
    [Breakpoint.XS]: 0.75,
    [Breakpoint.SM]: 0.75,
    [Breakpoint.MD]: 0.75,
    [Breakpoint.LG]: 0.75,
    [Breakpoint.XL]: 0.875,
    [Breakpoint.XXL]: 1,
};
